import request from '../../axios';

export const getTakenDirectLoanDetails = async (loanRequestGuid?: string) => {
  const {data}: {data: {total_balance: number; expire_date: string}} =
    await request.get(`/api/v2/payment/taken-direct-loan/` + loanRequestGuid);

  return data;
};
